const paths = {
  play: "M8 5.5v13a1 1 0 0 0 1.5.86l11-6.5a1 1 0 0 0 0-1.72l-11-6.5A1 1 0 0 0 8 5.5Z",
  pause: "M7 5h3.5v14H7zM13.5 5H17v14h-3.5z",
  close: "M6 6l12 12M18 6 6 18",
  back: "M15 5 8 12l7 7",
  settings:
    "M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm7.4-2.2.1-1.3-.1-1.3 2-1.6-2-3.4-2.4.9a7.5 7.5 0 0 0-2.2-1.3L14.4 3h-4l-.4 2.5c-.8.3-1.6.8-2.2 1.3l-2.4-.9-2 3.4 2 1.6-.1 1.3.1 1.3-2 1.6 2 3.4 2.4-.9c.7.5 1.4 1 2.2 1.3l.4 2.5h4l.4-2.5c.8-.3 1.5-.8 2.2-1.3l2.4.9 2-3.4-2-1.6Z",
  plus: "M12 5v14M5 12h14",
  trash: "M5 7h14M10 7V5h4v2M7 7l1 12h8l1-12",
  sliders: "M4 7h10M18 7h2M4 17h4M12 17h8M14 4v6M8 14v6",
  check: "M5 12.5 10 17 19 7",
  edit: "m5 19 1-4L16 5l3 3L9 18l-4 1Z",
  ear: "M8 9a4 4 0 1 1 8 0c0 2.5-2 3.2-2.6 5.2-.4 1.4-1.4 2.8-3 2.8M10 10a2 2 0 0 1 4 0",
  up: "m6 15 6-6 6 6",
  down: "m6 9 6 6 6-6",
  refresh: "M20 11a8 8 0 0 0-14.3-4.9L4 8M4 4v4h4M4 13a8 8 0 0 0 14.3 4.9L20 16M20 20v-4h-4",
  // тренажёры
  target: "M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18Zm0-4a5 5 0 1 1 0-10 5 5 0 0 1 0 10Zm0-4.5v-1",
  cycle: "M20 11a8 8 0 0 0-14.3-4.9L4 8M4 4v4h4M4 13a8 8 0 0 0 14.3 4.9L20 16M20 20v-4h-4",
  bolt: "M13 3 5 14h6l-1 7 8-11h-6l1-7Z",
  ghost: "M5 20V10a7 7 0 0 1 14 0v10l-2.3-1.6L14.3 20 12 18.4 9.7 20l-2.4-1.6L5 20ZM9.5 11v.5M14.5 11v.5",
  "heart-broken": "M12 20s-7-4.4-9-9a4.8 4.8 0 0 1 9-3 4.8 4.8 0 0 1 9 3c-2 4.6-9 9-9 9Zm0-12-1.6 4 3.2 1.6L12 17",
  eye: "M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Zm9.5 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
  thumbs: "M7 11v9H4v-9h3Zm0 0 4-7a2 2 0 0 1 2 2v4h5.5a2 2 0 0 1 2 2.3l-1.2 6A2 2 0 0 1 17.3 20H7",
  person: "M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 10a7 7 0 0 1 14 0",
  star: "m12 3 2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9L12 3Z",
  compass: "M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18Zm3.5-12.5-2 5-5 2 2-5 5-2Z",
  smile: "M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18ZM8.5 14s1.2 2 3.5 2 3.5-2 3.5-2M9 9.5v.5M15 9.5v.5",
  fingerprint: "M12 4a7 7 0 0 0-7 7v2M19 13v-2a7 7 0 0 0-3-5.7M9 20c1-2 1.5-4 1.5-7a1.5 1.5 0 0 1 3 0c0 2.5-.3 5-1.3 7M15.5 18.5c.4-1.6.5-3.3.5-5.5a4 4 0 0 0-8 0c0 1.5-.2 2.8-.6 4",
  heart: "M12 20s-7-4.4-9-9a4.8 4.8 0 0 1 9-3 4.8 4.8 0 0 1 9 3c-2 4.6-9 9-9 9Z",
  layers: "m12 3 9 5-9 5-9-5 9-5Zm-9 9 9 5 9-5M3 16l9 5 9-5",
  link: "M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3A4 4 0 0 0 11 18.7l1-1",
  scale: "M12 4v16M7 20h10M5 8h14M5 8l-2.5 6a2.5 2.5 0 0 0 5 0L5 8Zm14 0-2.5 6a2.5 2.5 0 0 0 5 0L19 8Z",
  ruler: "M4 16 16 4l4 4L8 20l-4-4Zm4-4 2 2m1-5 2 2m1-5 2 2",
  swap: "M7 7h13l-3-3M17 17H4l3 3",
  split: "M12 3v6m0 0-6 6v6m6-12 6 6v6",
  stop: "M7 7h10v10H7z",
  clock: "M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18Zm0-13v4.5l3 2",
  chevron: "m9 6 6 6-6 6",
} as const;

export type IconName = keyof typeof paths;

export function Icon({ name, size = 22, label }: { name: IconName; size?: number; label?: string }) {
  const filled = name === "play" || name === "pause" || name === "stop";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? "img" : undefined}
      fill={filled ? "currentColor" : "none"}
      stroke={filled ? "none" : "currentColor"}
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d={paths[name]} />
    </svg>
  );
}
